import { render } from "./RegisterSCAV.vue?vue&type=template&id=2c94014c&scoped=true"
import script from "./RegisterSCAV.vue?vue&type=script&lang=js"
export * from "./RegisterSCAV.vue?vue&type=script&lang=js"

import "./RegisterSCAV.vue?vue&type=style&index=0&id=2c94014c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c94014c"]])

export default __exports__